module.exports = "table {\n  width: 100%; }\n\n.label-header-dialog {\n  text-align: center;\n  color: #0A351C;\n  font-weight: bold; }\n"